import { render, staticRenderFns } from "./radioBox.vue?vue&type=template&id=a2db94b0&scoped=true"
import script from "./radioBox.vue?vue&type=script&lang=js"
export * from "./radioBox.vue?vue&type=script&lang=js"
import style0 from "./radioBox.vue?vue&type=style&index=0&id=a2db94b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2db94b0",
  null
  
)

export default component.exports